module.exports = __webpack_public_path__ + "static/media/league.162f0db2.svg";